import { render } from "./Column202307.vue?vue&type=template&id=b8dd667c&scoped=true"
import script from "./Column202307.vue?vue&type=script&lang=js"
export * from "./Column202307.vue?vue&type=script&lang=js"

import "./Column202307.vue?vue&type=style&index=0&id=b8dd667c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8dd667c"

export default script